module.exports = ".container-fluid {\n    padding-left: 85px;\n    padding-right: 15px;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    background-color: #f3f3f3;\n}\n\n.project-title {\n    font-weight: bold;\n    color: #707070;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project-view/project-view.component.css
// module id = ./src/app/projects/project-view/project-view.component.css
// module chunks = main